export const pkg = {
  name: 'isomorphic-git',
  version: '1.35.1',
  agent: 'git/isomorphic-git@1.35.1',
}
